import { MdOutlineAccountTree } from "react-icons/md";

const TreeStructureIcon = ({ size }) => {
  return <MdOutlineAccountTree size={size} className="no-shrink" />;
};

export default TreeStructureIcon;
